/** The most suggestion ids a bulk status, approval or terms call takes. */
export const MAX_IDS_PER_CALL = 500;

/** Suggestion ids split into calls of at most MAX_IDS_PER_CALL. */
export function idBatches(ids: readonly string[]): string[][] {
  const batches: string[][] = [];
  for (let start = 0; start < ids.length; start += MAX_IDS_PER_CALL) {
    batches.push(ids.slice(start, start + MAX_IDS_PER_CALL));
  }
  return batches;
}
